<template>
  <v-container fluid v-if="sprint != null">
    <v-layout row wrap>
      <sprint-edit-fields v-model="sprint" type="add"></sprint-edit-fields>
    </v-layout>
  </v-container>
</template>

<script>
import SprintEditFields from '@/components/SprintEditFields.vue';

export default {
  name: 'SprintAddView',
  components: { SprintEditFields },
  computed: {
    sprint: {
      get() {
        return {
        };
      },
      set(value) {
        this.$store.commit('createSprint', value);
        this.$router.push({ name: 'Sprints' });
      },
    },
  },
};
</script>
